module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "load-mask-parent"
  }, [_c('div', {
    class: _vm.loadMask
  }), _vm._v(" "), _c('form', [_vm._l((_vm.inputs || []), function(input, index) {
    return [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12"
    }, [_c(_vm.getComponentName(input.type), {
      tag: "component",
      attrs: {
        "label": input.label,
        "name": input.name,
        "event-bus": _vm.eventBus,
        "parentIndex": _vm.config.index,
        "value": input.value,
        "config": input
      },
      model: {
        value: (input.value),
        callback: function($$v) {
          _vm.$set(input, "value", $$v)
        },
        expression: "input.value"
      }
    })], 1)])]
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Submit')))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c97f972!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormComponent.vue
// module id = 1253
// module chunks = 2